import { formatUnixToTimeAndDate } from 'services/playResponsibly/playResponsibly.hooks';
import { useSelfExclusionQuery } from 'services/responsible-gaming-ms';
import { getDurationLabel } from '../helpers/get-duration-label';

/*-------------------------------------------------------------------------------------------------
 * hooks
 * -----------------------------------------------------------------------------------------------*/

function useSelfExclusion() {
  const { data } = useSelfExclusionQuery();

  const selfExclusionDurationUnit = getDurationLabel({
    durationInDays: data?.exclusionPeriodInDays,
    durationInMonths: data?.exclusionPeriodInMonths,
    durationInYears: data?.exclusionPeriodInYears,
  });

  const startDate = formatUnixToTimeAndDate(
    data?.selfExclusion?.startTimestamp ?? 0,
  );
  const endDate = formatUnixToTimeAndDate(
    data?.selfExclusion?.endTimestamp ?? 0,
  );

  return {
    ...data,
    selfExclusionDurationUnit,
    startDate,
    endDate,
  };
}

export { useSelfExclusion };
